import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { ideationWebsiteList_template } from "../components/templates/ideationWebsiteList_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class ideation_website extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: ideationWebsiteList_template;


    protected getModuleName(): string {

      return "ideation_website";
    }

    buildContent(): Array<Element> {

        this.elementsList = new ideationWebsiteList_template("list", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Ideation Websites");

        return [this.elementsList.build()];
    }

    public fillPage() {

      this.filterList();
    }

    protected paginationOnPageClick(){

      this.filterList();
    }

    protected websitesListReorder(){

      this.filterList();
    }

    protected filterSimpleOnChange(){

      this.viewModel.list.pagination.pageNumber(1);
      this.filterList();
    }

    protected filterSimpleCancel(){

      if( this.XHRHdl ){
          this.XHRHdl.cancelAndReset();
      }
    }

    protected filterList() {

      if (this.XHRHdl) {
          this.XHRHdl.cancelAndReset();
      }

      // LOADING : starts
      this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

      let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand +'/ideation/websites/get';
      let usrReq_params: Array<Array<string>> = [];
      usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())] );
      this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
      this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
      this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

      return function(){
          obj.manageResponse(req, obj, function(){

              let responseParsed = JSON.parse(req.request.response);
              obj.updateList(responseParsed);
          });
          obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
      }
    }

    protected updateList(responseParsed: any){

      let websitesToSet = responseParsed.data;

      this.elementsList.setWebsites(websitesToSet);

      let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
      this.elementsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

      this.viewModel.list.pagination.itemCount(responseParsed.totalCount);
    }

    protected saveWebsite(websiteToSave) {
      let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/ideation/websites/save/';
      let usrReq_params: Array<Array<string>> = [];
      usrReq_params.push(["data", ko.toJSON(websiteToSave)]);

      this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
      this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
      this.XHRHdl.onReadyStateFunction = this.onSaveWebsiteRequestReturn;
      this.XHRHdl.execute();
    }

    protected onSaveWebsiteRequestReturn(req, obj){

      return function(){
          obj.manageResponse(req, obj, function(){
              obj.filterList();
          });
      }
    }

    protected deleteWebsite(data) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url = "/api/brand/" + idBrand + "/ideation/websites/delete/" + data.id + "/"
        let formReq_params: Array<Array<string>> = [];

        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);
                    console.log(responseParsed)

                    obj.getVnAppZone().notification =
                        new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS,
                            "<strong>" + responseParsed.data.name + "</strong>" + "was successfully deleted");
                    obj.getVnAppZone().showNotificationToModule();
                    obj.filterList();
                })

                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));

            }
        });
        XHRHdl.execute();

    }

    public getIdBrand() {
      return Number(this.getVnAppZone().app.params.idBrand);
    }
}



// WEBPACK FOOTER //
// ./js/modules/ideation_website.ts